export default "__VITE_ASSET__CObIYW9M__"